import { Box } from '@mui/material';
import { AppointmentTimeOfDay } from 'apps/wrapper/src/services/appointment/types/appointment-time-of-day';
import { FC } from 'react';
import { useRequestDetailsView } from '../../../../hooks/use-request-details-view';
import { LabeledSection } from '../../../../shared/labeled-section/labeled-section';
import { PreferedDateList, PreferedDateListItem } from './preferred-date-section.styles';
import { getTimeOfDayText } from './utils/get-time-of-day-text';

export interface PreferredDateSectionProps {}

export const PreferredDateSection: FC<PreferredDateSectionProps> = (props) => {
  const { requestDetails } = useRequestDetailsView();

  const PreferedDateItem = ({ day, timeOfDay }: { day: string; timeOfDay?: AppointmentTimeOfDay }) => {
    const timeOfDayText = getTimeOfDayText(timeOfDay);

    if (!timeOfDayText) return null;

    return (
      <PreferedDateListItem>
        <Box>{day}</Box>
        <Box>{timeOfDayText}</Box>
      </PreferedDateListItem>
    );
  };

  if (!requestDetails.preferredTimesOfDay || Object.keys(requestDetails.preferredTimesOfDay).length == 0) return null;

  return (
    <LabeledSection label="Preferred Day & Time">
      <PreferedDateList>
        <PreferedDateItem day="Monday" timeOfDay={requestDetails.preferredTimesOfDay.mon} />
        <PreferedDateItem day="Tuesday" timeOfDay={requestDetails.preferredTimesOfDay.tue} />
        <PreferedDateItem day="Wednesday" timeOfDay={requestDetails.preferredTimesOfDay.wed} />
        <PreferedDateItem day="Thursday" timeOfDay={requestDetails.preferredTimesOfDay.thu} />
        <PreferedDateItem day="Friday" timeOfDay={requestDetails.preferredTimesOfDay.fri} />
        <PreferedDateItem day="Saturday" timeOfDay={requestDetails.preferredTimesOfDay.sat} />
        <PreferedDateItem day="Sunday" timeOfDay={requestDetails.preferredTimesOfDay.sun} />
      </PreferedDateList>
    </LabeledSection>
  );
};
